module.exports = __webpack_public_path__ + "img/just-sold-header.2800533e.png";